import { useEffect } from 'react';
import { useAppSelector } from '@store';
import { IconLoader, Table, useFilters } from '@ui/src';
import { CardPaymentSystem, CustomerCardsTransactionsTypes } from '../types';
import useCardsTranscations from '../hooks/use-cards';
import {
  overviewCardsColumns,
  overviewCardsColumnsLabels,
  overviewCardsFiltersSchema,
} from '../../statements/variables/statements-cards';
import formatCardTransacationList from '../../statements/helpers/format-card-transaction';

import cn from '../styles.module.css';

const CustomerCardsTransactions = ({
  customerType,
  cards,
}: CustomerCardsTransactionsTypes) => {
  const { isLoading, values, requestInProgress } = useAppSelector(
    (state) => state.customerCards,
  );

  const {
    onChangeCard,
    cardId,
    onSort,
    onFilter,
    filters,
    sort,
    onFilterChange,
  } = useCardsTranscations({
    customerType,
    cards,
    values,
  });

  const { filtersComponent, handleSubmit, reset } = useFilters({
    filtersSchema: overviewCardsFiltersSchema,
    filters,
    onFilterChange,
  });

  useEffect(() => {
    reset(filters);
  }, [filters, reset]);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.cardsTransactionsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <div className={cn.cardsTransactionsWrapper}>
        <div className={cn.cardsTransactionsTitle}>Transactions</div>
        <div className={cn.cardsTransactionsTabs}>
          {cards?.map((item) => (
            <button
              type="button"
              key={item.id}
              onClick={() => onChangeCard(item.id)}
              className={`${cn.cardsTransactionsTab} ${
                cardId === item.id ? cn.cardsTransactionsTabActive : ''
              }`}
              title={`${
                item.paymentSystem === CardPaymentSystem.MASTER_CARD
                  ? 'MC'
                  : 'VISA'
              } ${item.type} ${item.number}`}
            >
              {`${
                item.paymentSystem === CardPaymentSystem.MASTER_CARD
                  ? 'MC'
                  : 'VISA'
              } ${item.type} ${item.number}`}
            </button>
          ))}
        </div>
        {values && (
          <Table
            columns={overviewCardsColumns}
            data={formatCardTransacationList(values) || []}
            onSort={(name) => onSort(name)}
            filters={filters}
            sort={sort}
            columnsLabels={overviewCardsColumnsLabels}
            onFilterChange={(filterValues) => onFilter(filterValues)}
            filtersComponent={filtersComponent}
            handleSubmit={handleSubmit}
            isLoading={requestInProgress}
            tableFormClassName={cn.cardsTransactionsTableForm}
            tableHeadCellClassName={cn.cardsTransactionsTableHeadCell}
          />
        )}
      </div>
    );
  }

  return <div className={cn.cardsTransactions}>{content}</div>;
};

export default CustomerCardsTransactions;
